/**
 * The generated API client (`api3`) throws the raw, unwrapped response body on failed
 * requests instead of an `Error` instance — this can be a plain object shaped like a NestJS
 * exception (`{ message, path, statusCode, timestamp }`), or even a bare primitive (e.g. `false`)
 * if a backend endpoint responds with a non-2xx status and a JSON boolean body. Passing those
 * straight to `Sentry.captureException` produces uninformative "Object captured as exception"
 * or "Error: false" reports. Normalize to a real `Error` before reporting or inspecting `.message`.
 */
export function toError(value: unknown): Error {
  if (value instanceof Error) {
    return value;
  }

  if (value && typeof value === 'object' && 'message' in value && typeof (value as { message: unknown }).message === 'string') {
    const error = new Error((value as { message: string }).message);
    (error as Error & { cause?: unknown }).cause = value;
    return error;
  }

  const error = new Error(typeof value === 'string' ? value : JSON.stringify(value) ?? String(value));
  (error as Error & { cause?: unknown }).cause = value;
  return error;
}